import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import React from "react";
import {observer} from 'mobx-react';
import {MiniOrbitHomePageBox} from './boxes/mini-orbit-home-page.box';
import {ArenaGamesListsComponent} from "../../arena-games-lists/arena-games-lists.component";
import {HOME_PAGE_ARENA} from "../../../services/arenas/arena-consts";
import {FreeToPlayAnimatedIconComponent} from "../../free-to-play-animated-icon/free-to-play-animated-icon.component";

export const MiniOrbitHomePageComponent = observer(class MiniOrbitHomePageComponent extends OrbitComponent<{}> {

  render() {
    return (
      <MiniOrbitHomePageBox className={'cy-layout-wrapper-miniorbit-homepage'} key="MINI_ORBIT_HOME_PAGE">
        <ArenaGamesListsComponent key={"HOME_PAGE_LISTS"} arenaName={HOME_PAGE_ARENA} />
        <FreeToPlayAnimatedIconComponent />
      </MiniOrbitHomePageBox>
    );
  }
});